class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

function isB2BSession() {
  const body = document.body;
  if (!body) return false;
  if (body.classList.contains('b2b-active-session')) return true;

  if (window.__isB2BCustomer === true) return true;

  const customerTags = String(body.getAttribute('data-customer-tags') || '').toLowerCase();
  if (customerTags.indexOf('b2b') !== -1 || customerTags.indexOf('wholesale') !== -1) return true;

  const hasCompany = String(body.getAttribute('data-customer-has-company') || '').toLowerCase();
  return hasCompany === 'true' || hasCompany === '1';
}

function isWholesalePortalContext() {
  return !!document.querySelector('.wholesale-portal-container');
}

// B2B pre-init guard — runs before Rebuy initializes
// Extends existing isB2BSession() suppression; does not replace it.
(function() {
  if (typeof window.__b2bCheckoutNavigating === 'undefined') {
    window.__b2bCheckoutNavigating = false;
  }

  // Use existing __ptpCustomerB2b flag — do not re-evaluate B2B state
  var isB2B = window.__ptpCustomerB2b === true;
  if (!isB2B) return;

  // 1. RebuyConfig flag (pre-initialization suppression)
  //    Complements existing rebuy:smartcart.show listener — covers
  //    cases where Rebuy reads config before event listeners attach.
  if (typeof window.RebuyConfig === 'undefined' || window.RebuyConfig.smartCart !== false) {
    window.RebuyConfig = window.RebuyConfig || {};
    window.RebuyConfig.smartCart = false;
  }

  // 2. cart:open interception — not currently handled in cart.js
  //    Redirects to /cart if any component dispatches cart:open for B2B.
  document.addEventListener(
    'cart:open',
    function(e) {
      e.stopImmediatePropagation();
      window.location.href = '/cart';
    },
    true
  ); // capture phase — fires before any bubble-phase listeners

  // === Buildpath Overlay Race Condition Fix ===
  // Injected to resolve Rebuy/Buildpath/Corso AJAX event conflict.
  // Buildpath shows overlay → Rebuy intercepts response →
  // Buildpath completion event never fires → overlay freezes UI.
  // Runs only when window.__ptpCustomerB2b is true (same IIFE as above).
  (function buildpathOverlayFix() {
    function killOverlay() {
      var overlay = document.getElementById('buildpath__overlay');
      if (overlay) {
        overlay.style.display = 'none';
        overlay.style.pointerEvents = 'none';
      }
    }

    document.addEventListener('rebuy:cart.change', killOverlay);
    document.addEventListener('rebuy.cart.change', killOverlay);
    document.addEventListener('rebuy:cart:change', killOverlay);

    document.addEventListener('cart:updated', killOverlay);

    var overlayKillTimer = null;
    if (typeof window.fetch === 'function' && window.fetch && !window.fetch.__ptpB2BOverlayWrapped) {
      var originalFetch = window.fetch;
      var wrappedFetch = function () {
        var fetchArgs = arguments;
        return originalFetch.apply(this, fetchArgs).then(function (response) {
          var url = fetchArgs[0] || '';
          if (
            typeof url === 'string' &&
            (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
          ) {
            clearTimeout(overlayKillTimer);
            overlayKillTimer = setTimeout(killOverlay, 300);
          }
          return response;
        });
      };
      wrappedFetch.__ptpB2BOverlayWrapped = true;
      window.fetch = wrappedFetch;
    }

  })();
  // === End Buildpath Overlay Race Condition Fix ===

  // === B2B Checkout Instant Redirect ===
  // Replaces previous 500ms delayed version. Navigation guard prevents double-redirect.
  if (!window.__ptpB2BCheckoutDelayBound) {
    window.__ptpB2BCheckoutDelayBound = true;
    document.addEventListener(
      'click',
      function (e) {
        var checkoutBtn = e.target.closest(
          '[name="checkout"], ' +
            'button[data-checkout], ' +
            '.cart__checkout-button, ' +
            '[href="/checkout"]'
        );
        if (!checkoutBtn) return;
        if (window.__ptpCustomerB2b !== true) return;
        if (window.__b2bCheckoutNavigating) return;
        if (checkoutBtn.form) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        window.__b2bCheckoutNavigating = true;
        window.location.href = '/checkout';

        setTimeout(function () {
          window.__b2bCheckoutNavigating = false;
        }, 3000);
      },
      true
    );
  }
  // === End B2B Checkout Instant Redirect ===
})();

/** B2B / wholesale portal: hard navigation to cart — runs after DOM ready, uses isB2BSession() (not only __ptpCustomerB2b). */
function setupB2BCartNavHardRedirect() {
  if (window.__ptpB2BCartNavHardRedirectBound) return;
  window.__ptpB2BCartNavHardRedirectBound = true;

  function killBuildpathOverlay() {
    var overlay = document.getElementById('buildpath__overlay');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.style.pointerEvents = 'none';
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      if (
        e.target.closest(
          '[data-type="add-to-cart-form"] button, ' +
            '.product-form__submit, ' +
            'button[name="add"], ' +
            '[data-add-to-cart]'
        )
      ) {
        return;
      }

      if (!isB2BSession() && !isWholesalePortalContext()) return;

      var cartTarget = e.target.closest(
        '#headerCart a, ' +
          '.header-cart-page-link, ' +
          '.cart-icon-bubble, ' +
          'a.b2b-qo__view-cart-btn, ' +
          'a.b2b-qo__sticky-btn, ' +
          'a#b2b-qo-footer-checkout'
      );
      if (!cartTarget) return;

      var href = (cartTarget.getAttribute('href') || '').trim();
      e.preventDefault();
      e.stopImmediatePropagation();
      killBuildpathOverlay();
      if (!href || href === '#' || href.indexOf('javascript:') === 0) {
        window.location.href = '/cart';
      } else {
        window.location.href = href.split('#')[0];
      }
    },
    true
  );
}

function setupB2BSilentAddToCartLock() {
  if (window.__b2bSilentAddToCartLockBound) return;
  if (window.__ptpCustomerB2b !== true && !isWholesalePortalContext()) return;
  window.__b2bSilentAddToCartLockBound = true;

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!isB2BSession()) return;

      const isAddToCartForm =
        form.matches('[data-type="add-to-cart-form"]') ||
        form.matches('form[action*="/cart/add"]') ||
        form.querySelector('input[name="id"]');

      if (!isAddToCartForm) return;
      if (isWholesalePortalContext()) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return;
      }

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton && submitButton.getAttribute('data-b2b-silent-pending') === 'true') return;

      event.stopImmediatePropagation();
      event.preventDefault();

      if (submitButton) {
        submitButton.setAttribute('data-b2b-silent-pending', 'true');
        submitButton.setAttribute('aria-disabled', 'true');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);

      // Skio B2B: ensure selling_plan + subscription properties survive silent add.
      // FormData(form) usually includes them; re-assert from the active picker in case
      // the picker is associated via form= / form_id outside the submitter form.
      const skioPicker =
        form.querySelector('[skio-plan-picker]') ||
        document.querySelector('fieldset[skio-plan-picker][skio-auto-init]');
      const sellingPlanInput =
        form.querySelector('input[name="selling_plan"]') ||
        (skioPicker ? skioPicker.querySelector('input[name="selling_plan"]') : null);
      if (sellingPlanInput && sellingPlanInput.value) {
        formData.set('selling_plan', sellingPlanInput.value);
      } else if (sellingPlanInput && !sellingPlanInput.value) {
        formData.delete('selling_plan');
      }

      const propertySources = [];
      form.querySelectorAll('input[name^="properties["]').forEach(function (el) {
        propertySources.push(el);
      });
      if (skioPicker) {
        skioPicker.querySelectorAll('input[name^="properties["]').forEach(function (el) {
          propertySources.push(el);
        });
      }
      propertySources.forEach(function (propInput) {
        if (!propInput || propInput.disabled) return;
        if (propInput.value !== undefined && propInput.value !== null) {
          formData.set(propInput.name, propInput.value);
        }
      });

      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      let didSilentAddSucceed = false;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.text().then((text) => ({ response, text })))
        .then(({ response, text }) => {
          const payload = String(text || '').trim();
          if (!response.ok) {
            throw new Error(`B2B silent add failed with status ${response.status}`);
          }

          if (payload.slice(0, 16).toLowerCase().indexOf('<!doctype') === 0) {
            throw new Error('[B2B Cart] Expected JSON but received HTML from cart/add.');
          }

          try {
            JSON.parse(payload);
          } catch (error) {
            throw new Error('[B2B Cart] Unable to parse cart/add response JSON.');
          }

          didSilentAddSucceed = true;
        })
        .catch((error) => {
          console.error('[B2B Cart] Silent add to cart failed:', error);
        })
        .finally(() => {
          if (submitButton) {
            submitButton.removeAttribute('data-b2b-silent-pending');
            submitButton.removeAttribute('aria-disabled');
          }
          if (didSilentAddSucceed) {
            document.dispatchEvent(new CustomEvent('b2b:cart-silent-updated'));
          }
        });
    },
    true
  );
}

function setupB2BCartDrawerSuppression() {
  if (window.__b2bCartDrawerSuppressionBound) return;
  window.__b2bCartDrawerSuppressionBound = true;

  document.addEventListener(
    'rebuy:smartcart.show',
    (event) => {
      if (!isB2BSession() && !isWholesalePortalContext()) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const drawer = document.getElementById('rebuy-cart');
      if (drawer) {
        drawer.style.setProperty('display', 'none', 'important');
        drawer.setAttribute('aria-hidden', 'true');
      }

      const smartcart = event && event.detail ? event.detail.smartcart : null;
      if (smartcart && typeof smartcart.hide === 'function') {
        try {
          smartcart.hide();
        } catch (error) {
          console.error('[B2B Cart] Unable to hide Rebuy SmartCart:', error);
        }
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!isB2BSession() && !isWholesalePortalContext()) return;
      const notification = document.getElementById('cart-notification');
      if (!notification || !notification.classList.contains('active')) return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('cart-notification')) return;
      notification.classList.remove('active', 'animate');
      notification.setAttribute('aria-hidden', 'true');
    },
    true
  );
}

function initB2BFeatures() {
  // Gate: only attach global listeners if Liquid confirms B2B session
  // OR if the current page is the wholesale portal template.
  // This prevents isB2BSession() false-positives from leaking
  // B2B interceptors into retail sessions.
  if (window.__ptpCustomerB2b === true || isWholesalePortalContext()) {
    setupB2BCartNavHardRedirect();
    setupB2BSilentAddToCartLock();
    setupB2BCartDrawerSuppression();
  }
  // Retail users: none of the above functions are called.
  // Rebuy SmartCart initializes normally without interference.
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initB2BFeatures);
} else {
  initB2BFeatures();
}

// ─── B2B Cart Quantity Controller ───────────
// Native Shopify cart only (not Rebuy Smart Cart). Mutex + debounce
// so rapid +/- clicks resolve to the FINAL desired quantity.
(function setupB2BCartQuantityController() {
  function isB2BCartQtyContext() {
    if (document.body && document.body.classList.contains('rebuy-cart-active')) return false;
    if (window.__ptpCustomerB2b === true) return true;
    if (document.body && document.body.classList.contains('b2b-active-session')) return true;
    if (document.body && document.body.getAttribute('data-customer-b2b') === 'true') return true;
    return !!document.querySelector('.b2b-native-cart-item');
  }

  if (window.__b2bCartQtyControllerBound) return;
  window.__b2bCartQtyControllerBound = true;

  var CartQty = (function () {
    var _state = {};
    var _locked = {};
    var _timers = {};
    var _pendingFlush = {};

    function resolveKey(input) {
      if (!input) return null;
      var row = input.closest('[data-cart-key], .b2b-native-cart-item, .cart-item');
      if (row && row.dataset && row.dataset.cartKey) return row.dataset.cartKey;
      var name = input.getAttribute('name') || '';
      var match = name.match(/updates\[([^\]]+)\]/);
      return match ? match[1] : null;
    }

    function resolveLine(input, key) {
      if (input && input.dataset && input.dataset.line) {
        return parseInt(input.dataset.line, 10);
      }
      var row = input ? input.closest('[data-line], .b2b-native-cart-item, .cart-item') : null;
      if (row && row.dataset && row.dataset.line) {
        return parseInt(row.dataset.line, 10);
      }
      if (row && row.id) {
        var idMatch = row.id.match(/(?:B2BCartItem|CartItem)-(\d+)/);
        if (idMatch) return parseInt(idMatch[1], 10);
      }
      var inputs = document.querySelectorAll(
        '.b2b-native-cart-item .quantity__input, .cart-item .quantity__input'
      );
      for (var i = 0; i < inputs.length; i++) {
        if (resolveKey(inputs[i]) === key) return i + 1;
      }
      return null;
    }

    function findInput(key, line) {
      var byKey = document.querySelector(
        '[data-cart-key="' + key + '"] .quantity__input, input[name="updates[' + key + ']"]'
      );
      if (byKey) return byKey;
      if (line) {
        return document.querySelector(
          'input[data-line="' + line + '"], #B2BQuantity-' + line + ', #Quantity-' + line
        );
      }
      return null;
    }

    function findRow(key, input) {
      if (input) {
        var row = input.closest('.b2b-native-cart-item, .cart-item, [data-cart-key]');
        if (row) return row;
      }
      return document.querySelector(
        '[data-cart-key="' + key + '"], input[name="updates[' + key + ']"]'
      )
        ? document
            .querySelector('input[name="updates[' + key + ']"]')
            .closest('.b2b-native-cart-item, .cart-item')
        : null;
    }

    function setQty(key, line, newQty) {
      if (!key) return;
      _state[key] = Math.max(0, parseInt(newQty, 10) || 0);

      var input = findInput(key, line);
      if (input) {
        input.value = String(_state[key]);
        input.dataset.b2bOptimistic = 'true';
      }

      clearTimeout(_timers[key]);
      _timers[key] = setTimeout(function () {
        _flush(key, line);
      }, 400);
    }

    function _flush(key, line) {
      if (_locked[key]) {
        _pendingFlush[key] = { line: line };
        return;
      }

      var qty = _state[key];
      if (qty === undefined) return;

      _locked[key] = true;
      _setButtonsDisabled(key, true);

      // Use line-item key as id — stable across concurrent edits (avoids line-index races)
      var payload = {
        id: key,
        quantity: qty,
      };

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart change failed: ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          window.__cartData = cart;
          _updateSubtotal(cart);
          _updateLinePrices(cart);
          _updateSavings(cart);

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cart },
            })
          );

          if (qty === 0) {
            var row = findRow(key, findInput(key, line));
            if (row) {
              row.style.opacity = '0';
              row.style.transition = 'opacity 0.3s ease';
              setTimeout(function () {
                row.remove();
                if (!document.querySelector('.b2b-native-cart-item, .cart-item')) {
                  window.location.reload();
                }
              }, 300);
            }
          } else {
            var serverItem = (cart.items || []).find(function (item) {
              return item.key === key;
            });
            var serverQty = serverItem ? serverItem.quantity : 0;
            var input = findInput(key, line);
            if (serverQty !== _state[key]) {
              _state[key] = serverQty;
              if (input) input.value = String(serverQty);
            }
          }
        })
        .catch(function (err) {
          // Reloading here was the old recovery, and it produced the reported
          // behaviour: the page reloaded and the quantity snapped back, with no clue
          // why — the reload discarded the console error along with everything else.
          // Restore the field from the last known-good server quantity instead and
          // leave the error where it can be read.
          console.error('[CartQty] /cart/change.js failed for key ' + key + ':', err);

          var serverCart = window.__cartData;
          var known = null;
          if (serverCart && Array.isArray(serverCart.items)) {
            serverCart.items.forEach(function (it) {
              if (it && it.key === key) known = it.quantity;
            });
          }

          var revertInput = findInput(key, line);
          if (known !== null) {
            _state[key] = known;
            if (revertInput) revertInput.value = String(known);
          } else if (revertInput) {
            delete _state[key];
          }
        })
        .finally(function () {
          _locked[key] = false;
          _setButtonsDisabled(key, false);

          if (_pendingFlush[key]) {
            var pending = _pendingFlush[key];
            delete _pendingFlush[key];
            _flush(key, pending.line || line);
            return;
          }

          if (_timers[key]) return;
          delete _state[key];
        });
    }

    function _setButtonsDisabled(key, disabled) {
      var row = findRow(key, findInput(key));
      if (!row) return;
      row.querySelectorAll('.b2b-qty-btn').forEach(function (btn) {
        btn.disabled = !!disabled;
        btn.style.opacity = disabled ? '0.4' : '1';
      });
    }

    function _updateSubtotal(cart) {
      var subtotalEl = document.querySelector(
        '.totals__subtotal-value, .cart-summary-b2b__value--strong, [data-cart-subtotal]'
      );
      if (!subtotalEl || !cart) return;
      var currency = cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try {
        subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: currency,
        });
      } catch (e) {
        subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
      }
    }

    function _formatCents(cents, currency) {
      try {
        return (cents / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: currency || 'USD',
        });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    // Retail reference price per unit, in cents, published by main-cart-items.liquid
    // from the retail_msrp metafield. 0 means the line has no retail reference.
    function _unitRetailCents(row) {
      var raw = row && row.getAttribute('data-unit-retail');
      var cents = parseInt(raw, 10);
      return isNaN(cents) || cents < 0 ? 0 : cents;
    }

    function _updateLinePrices(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var currency = cart.currency || 'USD';
      cart.items.forEach(function (item) {
        var row = findRow(item.key);
        if (!row) return;

        var priceEl = row.querySelector(
          '.b2b-native-cart-item__price, .cart-item__final-price, .price'
        );
        if (priceEl) {
          priceEl.textContent = _formatCents(item.final_line_price, currency);
        }

        // Retail strike and per-line saving both scale with quantity.
        var unitRetail = _unitRetailCents(row);
        if (unitRetail === 0) return;

        var retailLine = unitRetail * item.quantity;
        var saving = retailLine - item.final_line_price;

        var strikeEl = row.querySelector('[data-line-retail] s');
        if (strikeEl) strikeEl.textContent = _formatCents(retailLine, currency);

        var savingEl = row.querySelector('[data-line-savings]');
        if (savingEl) {
          if (saving > 0) {
            savingEl.textContent = 'Save ' + _formatCents(saving, currency);
            savingEl.hidden = false;
          } else {
            savingEl.hidden = true;
          }
        }
      });
    }

    // Cart-wide retail saving. Mirrors the Liquid in main-cart-footer.liquid:
    // sum of (unit retail x quantity) - final line price, across lines that have
    // a retail reference. Excludes the volume-tier discount, which the Shopify
    // Function applies at checkout and is therefore absent from cart totals.
    // Projected volume-tier percentage. Mirrors
    // extensions/b2b-volume-discount/src/run.rs and must stay in step with it and
    // with the TIERS array in snippets/b2b-volume-discount-table.liquid.
    function _tierPct(totalUnits) {
      if (totalUnits >= 40) return 40;
      if (totalUnits >= 25) return 35;
      if (totalUnits >= 12) return 30;
      if (totalUnits >= 6) return 25;
      return 0;
    }

    function _updateSavings(cart) {
      var row = document.querySelector('[data-b2b-savings-row]');
      var note = document.querySelector('[data-b2b-savings-note]');
      var valueEl = document.querySelector('[data-b2b-savings-value]');
      if (!row || !valueEl || !cart || !Array.isArray(cart.items)) return;

      // Both components need real numbers. A payload without them — Rebuy passes
      // partial cart objects, and some events fire before the data lands — used to
      // compute zeros and hide the row, which is why the figure read 0 on arrival and
      // only corrected after a refresh. Leaving early keeps the server-rendered
      // Liquid values, which were right to begin with.
      if (typeof cart.total_price !== 'number' || typeof cart.item_count !== 'number') {
        return;
      }

      var currency = cart.currency;

      // Component one: the retail gap, already reflected in the prices on screen.
      var retail = 0;
      cart.items.forEach(function (item) {
        var itemRow = findRow(item.key);
        var unitRetail = _unitRetailCents(itemRow);
        if (unitRetail === 0) return;
        var saving = unitRetail * item.quantity - item.final_line_price;
        if (saving > 0) retail += saving;
      });

      // Component two: the tier the Function will apply at checkout. Not present in
      // any cart figure, which is why the total looked like the retail gap alone.
      // Not cart.item_count / cart.total_price: both count the Corso shipping
      // protection line, which the Function excludes from the tier and from the
      // discounted subtotal. The helpers come from layout/theme.liquid, which
      // builds them from snippets/b2b-discount-exclusions.liquid.
      var units =
        typeof window.__ptpDiscountableUnits === 'function'
          ? window.__ptpDiscountableUnits(cart)
          : cart.item_count || 0;
      var eligible =
        typeof window.__ptpDiscountableSubtotal === 'function'
          ? window.__ptpDiscountableSubtotal(cart)
          : cart.total_price;
      var pct = _tierPct(units);
      var tier = pct > 0 ? Math.round((eligible * pct) / 100) : 0;
      var total = retail + tier;

      var retailPart = document.querySelector('[data-b2b-retail-part]');
      var tierPart = document.querySelector('[data-b2b-tier-part]');
      var tierNone = document.querySelector('[data-b2b-tier-none]');

      if (retailPart) {
        retailPart.textContent = _formatCents(retail, currency) + ' vs. retail';
        retailPart.hidden = retail <= 0;
      }

      if (tierPart) {
        tierPart.textContent =
          _formatCents(tier, currency) + ' volume tier (' + pct + '%), applied at checkout';
        tierPart.hidden = tier <= 0;
      }

      if (tierNone) tierNone.hidden = pct > 0;

      if (total > 0) {
        valueEl.textContent = _formatCents(total, currency);
        row.hidden = false;
        if (note) note.hidden = false;
      } else {
        row.hidden = true;
        if (note) note.hidden = true;
      }
    }

    return {
      setQty: setQty,
      resolveKey: resolveKey,
      resolveLine: resolveLine,
      getDesired: function (key, input) {
        if (_state[key] !== undefined) return _state[key];
        return parseInt(input && input.value, 10) || 0;
      },
      injectQtyButtons: null,
      // Exposed so cart changes that bypass this controller (Rebuy events, the
      // centralized dispatcher) can refresh the retail-savings figures too.
      refreshSavings: function (cart) {
        _updateLinePrices(cart);
        _updateSavings(cart);
      },
    };
  })();

  window.CartQty = CartQty;

  function normalizeCartItems(cartData) {
    if (!cartData) return null;
    if (Array.isArray(cartData.items)) return cartData;
    // Rebuy sometimes passes the items array as detail.cart itself
    if (Array.isArray(cartData)) {
      return { items: cartData };
    }
    // Only coerce when `items` exists but is not an array (object/map/string)
    if (Object.prototype.hasOwnProperty.call(cartData, 'items') && cartData.items != null) {
      if (typeof cartData.items === 'object') {
        var mapped = [];
        Object.keys(cartData.items).forEach(function (k) {
          var entry = cartData.items[k];
          if (entry && typeof entry === 'object') mapped.push(entry);
        });
        return Object.assign({}, cartData, { items: mapped });
      }
      return Object.assign({}, cartData, { items: [] });
    }
    // Leave payloads like { source: 'cart-items' } untouched
    return cartData;
  }

  function injectQtyButtons() {
    if (!isB2BCartQtyContext()) return 0;

    var items = document.querySelectorAll('.b2b-native-cart-item');
    if (!items.length) return 0;

    var injected = 0;
    items.forEach(function (item) {
      var wrap = item.querySelector(
        '.b2b-qty-wrap, .quantity, .quantity__wrapper, [class*="quantity"]'
      );
      var input = item.querySelector('.quantity__input, input[name^="updates"]');
      if (!wrap || !input) return;
      if (item.querySelector('.b2b-qty-btn') || wrap.querySelector('.b2b-qty-btn')) return;

      if (!input.parentElement.classList.contains('b2b-qty-wrap')) {
        var qtyWrap = document.createElement('div');
        qtyWrap.className = 'quantity b2b-qty-wrap';
        input.parentNode.insertBefore(qtyWrap, input);
        qtyWrap.appendChild(input);
        wrap = qtyWrap;
      }

      var key = item.dataset.cartKey || CartQty.resolveKey(input);
      if (!key && input.name) {
        key = String(input.name).replace(/^updates\[/, '').replace(/\]$/, '');
      }
      var line = item.dataset.line || input.dataset.line || CartQty.resolveLine(input, key);
      if (!key) return;

      if (!item.dataset.cartKey) item.dataset.cartKey = key;
      if (!input.dataset.line && line) input.dataset.line = String(line);

      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'b2b-qty-btn b2b-qty-btn--minus';
      minus.setAttribute('aria-label', 'Decrease quantity');
      minus.textContent = '−';
      minus.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var cur = CartQty.getDesired(key, input);
        CartQty.setQty(key, line, cur - 1);
      });

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'b2b-qty-btn b2b-qty-btn--plus';
      plus.setAttribute('aria-label', 'Increase quantity');
      plus.textContent = '+';
      plus.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var cur = CartQty.getDesired(key, input);
        CartQty.setQty(key, line, cur + 1);
      });

      input.addEventListener('change', function () {
        if (input.dataset.b2bOptimistic === 'true') {
          delete input.dataset.b2bOptimistic;
          return;
        }
        CartQty.setQty(key, line, parseInt(input.value, 10) || 0);
      });

      wrap.insertBefore(minus, input);
      wrap.appendChild(plus);
      injected++;
    });

    return injected;
  }

  CartQty.injectQtyButtons = injectQtyButtons;

  // ── Remove ───────────────────────────────────────────────────────────
  // Routes the remove control through the same /cart/change.js path the +/- buttons
  // use, so a removal is fluid instead of a full page navigation. The control is a
  // link to item.url_to_remove (see sections/main-cart-items.liquid), so if this
  // listener never runs the line is still removed correctly — just with a reload.
  //
  // Delegated on document because rows are re-rendered and removed.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[data-b2b-remove]');
    if (!trigger) return;
    if (!isB2BCartQtyContext()) return;

    var row = trigger.closest('.b2b-native-cart-item, .cart-item');
    var input = row ? row.querySelector('.quantity__input, input[name^="updates"]') : null;

    // The key is on the trigger itself rather than read off the row, so removal does
    // not depend on the row markup. Without one, fall through to the link.
    var key = trigger.getAttribute('data-b2b-remove') || CartQty.resolveKey(input);
    if (!key) return;

    event.preventDefault();

    var line =
      (row && row.dataset && row.dataset.line) ||
      (input && input.dataset && input.dataset.line) ||
      CartQty.resolveLine(input, key);

    CartQty.setQty(key, line, 0);
  });

  // ── Cart state ───────────────────────────────────────────────────────
  // cart.js owns cart state; the progress banner owns the tier math and
  // subscribes through `cart:updated`. Keeping a single source of truth is
  // why the quantity total is not recomputed here.
  var _cartFetchInFlight = false;
  // The server-confirmed unit total. Used to tell a real empty cart apart
  // from an app broadcasting a placeholder payload before its data loads.
  var _confirmedQty = 0;
  var _hasInitialized = false;

  function cartQtyOf(cart) {
    if (!cart) return 0;
    if (typeof cart.item_count === 'number') return cart.item_count;
    if (!Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (s, i) {
      return s + ((i && i.quantity) || 0);
    }, 0);
  }

  function broadcastCart(cart) {
    var normalized = normalizeCartItems(cart);
    if (!normalized || !Array.isArray(normalized.items)) return;
    // Set before dispatching: the capture listener below reads _confirmedQty
    // to decide what is suspicious, and a genuine empty cart must pass.
    _confirmedQty = cartQtyOf(normalized);
    _hasInitialized = true;
    window.__cartData = normalized;
    console.log('[B2B CartQty] broadcast qty:', _confirmedQty);
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: normalized, source: 'cart-qty-controller' },
      })
    );
  }

  // The server is the only authority on cart contents. Seeds window.__cartData
  // on load and re-resolves it whenever an app claims the cart went empty.
  function fetchAndUpdateCart() {
    if (_cartFetchInFlight) return;
    _cartFetchInFlight = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      })
      .then(broadcastCart)
      .catch(function () {
        /* silent — the banner falls back to reading quantities from the DOM */
      })
      .finally(function () {
        _cartFetchInFlight = false;
      });
  }

  // ── Init ─────────────────────────────────────────────────────────────
  var _initTimer = null;

  function initCartQty() {
    if (!isB2BCartQtyContext()) return 0;

    var injected = injectQtyButtons();
    if (injected > 0) {
      console.log('[B2B CartQty] Injected ' + injected + ' qty controls');
    }

    // Always resolve against the server on init rather than trusting whatever
    // an app left on window.__cartData.
    if (!_hasInitialized) fetchAndUpdateCart();

    return injected;
  }

  function scheduleInit(delay) {
    clearTimeout(_initTimer);
    _initTimer = setTimeout(initCartQty, delay || 0);
  }

  // Replaces the fixed-interval retry loop: react to cart rows actually
  // entering the DOM instead of guessing how long rendering will take.
  if ('MutationObserver' in window) {
    var _observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if (
            (node.classList && node.classList.contains('b2b-native-cart-item')) ||
            (node.querySelector && node.querySelector('.b2b-native-cart-item'))
          ) {
            scheduleInit(50);
            return;
          }
        }
      }
    });
    _observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('shopify:section:load', function () {
    scheduleInit(50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleInit(100);
    });
  } else {
    scheduleInit(100);
  }

  window.addEventListener('load', function () {
    scheduleInit(0);
  });

  // ── Centralized cart event dispatcher ────────────────────────────────
  // One capture-phase listener per event, replacing the three overlapping
  // handlers that each re-queried the DOM.
  var _reinjectTimer = null;

  function scheduleReinject() {
    clearTimeout(_reinjectTimer);
    _reinjectTimer = setTimeout(injectQtyButtons, 50);
  }

  // 'rebuy:cart.change' is Rebuy's documented change event and the reliable signal here.
  // 'rebuy:cart.updated' is NOT a Rebuy event name (kept as a harmless no-op); before it
  // was added, the only Rebuy signal reaching this dispatcher was cart.ready, which fires
  // with an empty items array — see the guard below and CLAUDE.md.
  ['cart:updated', 'rebuy:cart.change', 'rebuy:cart.updated', 'rebuy:cart.ready'].forEach(function (evt) {
    document.addEventListener(
      evt,
      function (e) {
        try {
          var detail = e && e.detail;
          var raw = detail && (detail.cart || (detail.data && detail.data.cart));
          var normalized = normalizeCartItems(raw);
          var hasItems = !!normalized && Array.isArray(normalized.items);

          // Rebuy fires cart.ready with an empty items array before its own
          // data loads. Taken at face value it zeroes a cart we already know
          // has contents, which is what made the progress bar reset on load.
          if (hasItems && normalized.items.length === 0 && (_confirmedQty > 0 || !_hasInitialized)) {
            console.warn(
              '[B2B CartQty] ' + evt + ' claimed empty cart; confirmed qty: ' + _confirmedQty
            );
            // Capture phase runs before the banner's listener, so swapping in
            // the known-good cart keeps the bar steady while we re-check.
            if (detail && window.__cartData && cartQtyOf(window.__cartData) > 0) {
              detail.cart = window.__cartData;
            }
            fetchAndUpdateCart();
            return;
          }

          // Repair the payload in place so listeners further down the chain
          // never hit `.items.reduce` on a non-array.
          if (normalized && detail) detail.cart = normalized;
          if (hasItems) {
            window.__cartData = normalized;
            _confirmedQty = cartQtyOf(normalized);
            _hasInitialized = true;
            // Keep the retail-savings figures in step with carts changed outside
            // the B2B quantity controller. Only on payloads that cleared the
            // empty-cart guard above, so a spurious event cannot zero them.
            if (window.CartQty && typeof CartQty.refreshSavings === 'function') {
              CartQty.refreshSavings(normalized);
            }
          }
          scheduleReinject();
        } catch (err) {
          console.warn('[B2B CartQty] ' + evt + ' error:', err);
        }
      },
      true
    );
  });
})();
// ─── End B2B Cart Quantity Controller ───────

function updateFreeShippingProgress(root = document) {
  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  };

  root.querySelectorAll('[data-free-shipping-progress]').forEach((node) => {
    const threshold = parseInt(node.getAttribute('data-free-shipping-threshold-cents'), 10) || 0;
    const current = parseInt(node.getAttribute('data-free-shipping-current-cents'), 10) || 0;
    const fill = node.querySelector('[data-free-shipping-fill]');
    const message = node.querySelector('[data-free-shipping-message]');

    if (!threshold || !fill || !message) return;

    const capped = Math.max(0, Math.min(current, threshold));
    const percent = Math.max(0, Math.min((capped / threshold) * 100, 100));
    const remaining = Math.max(0, threshold - current);

    fill.style.width = `${percent}%`;
    message.textContent =
      remaining > 0
        ? `${formatMoney(remaining)} away from Free Shipping`
        : 'You unlocked Free Shipping';
  });
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    updateFreeShippingProgress(document);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        this.updateLiveRegions(line, parsedState.item_count);
        updateFreeShippingProgress(document);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
        if (document.body.classList.contains('template-cart')) {
          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'cart-items' } })
          );
        }
      })
      .catch(() => {
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading() {
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }
  }
}

customElements.define('cart-items', CartItems);

// Rebuy-aware Corso refresh — Corso can inject before Rebuy finishes rendering.
(function () {
  function triggerCorsoRefresh() {
    if (window.Corso && typeof window.Corso.refresh === 'function') {
      window.Corso.refresh();
      return;
    }
    if (window.__cartData) {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: window.__cartData },
        })
      );
    }
  }

  // Debounced: 'rebuy:cart.change' fires on every add/remove/quantity change, so the
  // previous per-event setTimeout would stack refreshes. Last call wins.
  var _corsoRefreshTimer = null;
  function scheduleCorsoRefresh(delay) {
    clearTimeout(_corsoRefreshTimer);
    _corsoRefreshTimer = setTimeout(triggerCorsoRefresh, delay);
  }

  // 'rebuy:cart.updated' and 'rebuy:smart-cart.open' are not Rebuy event names and never
  // fire; kept as harmless no-ops next to the documented ones. See CLAUDE.md.
  ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.updated'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      scheduleCorsoRefresh(300);
    });
  });

  ['rebuy:smartcart.show', 'rebuy:smart-cart.open'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      scheduleCorsoRefresh(500);
    });
  });

  var corsoCheckInterval = setInterval(function () {
    if (window.Corso) {
      triggerCorsoRefresh();
      clearInterval(corsoCheckInterval);
    }
  }, 500);

  setTimeout(function () {
    clearInterval(corsoCheckInterval);
  }, 10000);
})();
